import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckoutFormSection } from "../CheckoutFormSection";
import { CheckoutFormAccountDetails } from "./CheckoutFormAccountDetails";
import { CheckoutFormAccountFields } from "./CheckoutFormAccountFields";
import { CheckoutFormEmailVerification } from "./CheckoutFormEmailVerification";

export const CheckoutFormAccountInfo = () => {
  const { currentUser, loginRedirectUrl } = usePaywallCheckoutContext();
  const { currentCommunitySettings, isLoading: isCommunityLoading } =
    usePunditUserContext();
  const isOtpPaywallSignInEnabled = Boolean(
    currentCommunitySettings?.otp_paywall_sign_in_enabled,
  );

  if (isCommunityLoading) return null;

  return (
    <div className="flex flex-col gap-y-4 lg:pb-6">
      <div>
        <Typography.TitleSm weight="semibold">
          {isOtpPaywallSignInEnabled || currentUser
            ? t("paywall_checkout.your_account")
            : t("paywall_checkout.create_your_account")}
        </Typography.TitleSm>
        {!isOtpPaywallSignInEnabled && !currentUser && (
          <Typography.BodyXs weight="regular">
            {t("paywall_checkout.have_an_account")}
            <a href={loginRedirectUrl} data-testid="checkout-form-sign-in-link">
              {t("paywall_checkout.form.buttons.sign_in")}
            </a>
          </Typography.BodyXs>
        )}
      </div>

      <CheckoutFormSection className="gap-y-5 !py-0">
        {currentUser ? (
          <CheckoutFormAccountDetails />
        ) : isOtpPaywallSignInEnabled ? (
          <CheckoutFormEmailVerification />
        ) : (
          <CheckoutFormAccountFields />
        )}
      </CheckoutFormSection>
    </div>
  );
};
